import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { filter, from, iif, interval, map, of, switchMap, take } from 'rxjs';
import { MatrixService } from '../../services/matrix/matrix.service';

/**
 * Guard, der den Zugriff auf die Login-Komponente nur zulässt,
 * wenn nicht bereits ein Client eingeloggt ist und wenn keine persistierte Session vorliegt.
 */
export const loginGuard: CanActivateFn = () => {
  const router = inject(Router);
  const clientService = inject(MatrixService);
  const item = sessionStorage.getItem('keybackupinteraction');

  if (clientService.hasClient && !item) return router.parseUrl('/keybackup');

  return from(clientService.restoreSession('')).pipe(
    switchMap((restoreSuccess: boolean) =>
      iif(
        () => restoreSuccess,
        interval(500).pipe(
          // alle 500ms prüfen
          filter(() => clientService.client.isInitialSyncComplete()), // nur durchlassen, wenn function1() true ergibt
          take(1), // nur einmal true abwarten
          map(() => router.parseUrl('/rooms'))
        ),
        of(true)
      )
    )
  );
};
